"use client";

import { useState, FormEvent } from "react";
import { useRouter } from "next/navigation";

import Button from "@components/ui/form/button";
import TextInput from "@components/ui/form/text-input";
import { ParallaxSection, Speedline, Transition } from "@components/ui/motion";

const REGNR_REGEX = /^[A-Za-z]{3}\s?[0-9]{2}[A-Za-z0-9]{1}$/;
const INVALID_MESSAGE = "Ange ett giltigt registreringsnummer, t.ex. ABC123.";

const RegNrCapture = () => {
	const router = useRouter();
	const [value, setValue] = useState("");
	const [error, setError] = useState<string | null>(null);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const normalized = value.trim().toUpperCase().replace(/\s+/g, "");
		if (!REGNR_REGEX.test(normalized)) {
			setError(INVALID_MESSAGE);
			return;
		}
		setError(null);
		setIsSubmitting(true);
		router.push(`/salj-ditt-fordon?regnr=${encodeURIComponent(normalized)}`);
	};

	return (
		<form
			onSubmit={handleSubmit}
			className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto items-start sm:items-end"
		>
			<div className="w-full sm:flex-1">
				<TextInput
					placeholder="ABC123"
					aria-label="Registreringsnummer"
					value={value}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						setValue(e.target.value.toUpperCase());
						if (error) setError(null);
					}}
					error={error ? { message: error } : undefined}
					autoComplete="off"
					maxLength={7}
				/>
			</div>
			<Button type="submit" loading={isSubmitting} className="w-full sm:w-auto">
				Få värdering
			</Button>
		</form>
	);
};

const SellYourCarParallax = () => {
	return (
		<ParallaxSection
			image="/sell-parallax-bg.jpg"
			height="80vh"
			overlayOpacity={0.65}
		>
			<div className="content-container text-center text-white px-4">
				<Transition type="SlideUp">
					<div className="flex justify-center">
						<Speedline className="mb-6" width="6rem" />
					</div>
					<h2 className="mb-4">Trygg bilaffär från start till mål.</h2>
					<p className="max-w-xl mx-auto mb-8 text-slate-200">
						Ange regnr — vi återkommer med värdering inom 24 timmar.
					</p>
					<RegNrCapture />
				</Transition>
			</div>
		</ParallaxSection>
	);
};

export default SellYourCarParallax;
